(function wishlist() {
	var wishlistChanged = false;
	const wishlistScript = document.querySelector('[data-cake-wishlist-token]');
	const pageSize = 20;

	if (!wishlistScript) return;

	const delegate = new domDelegate.Delegate(document.body);
	const customerID = wishlistScript.dataset.cakeWishlistCustomer;
	const token = wishlistScript.dataset.cakeWishlistToken;
	
	try {
		var wishlist = JSON.parse(wishlistScript.textContent);
	} catch (e) {}
	wishlist = wishlist || [];

	const drawer = document.getElementById('wishlist-drawer');

	// Listen for the wishlist drawer being opened
	const drawerObserver = new MutationObserver(async mutationList => {
		for (const mutation of mutationList) {
			if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
				if (mutation.target.ariaHidden === 'false') {
					await loadWishlist();
				}
			}
		}
	});
	drawerObserver.observe(drawer, {attributeFilter: ['aria-hidden']});

	if (!drawer.querySelector('.Drawer__Main .Drawer__Container > :first-child')) {
		// Drawer container is empty
		wishlistChanged = true;
	}

	const getWishlistProductHandles = async () => {
		var handles_available = [];
		var handles_unavailable = [];
		let ids = [...wishlist].reverse().map(item => getGID(item.product_id));
		let pageIds = [];
		let fetched = 0;
		let products = [];
		try {
			do {
				pageIds = ids.slice(fetched, fetched + 250);
				var query = JSON.stringify({
					query: `
						query($ids: [ID!]!) @inContext(country: ${window.Shopify.country}, language: ${window.Shopify.locale.toUpperCase()})  {
							nodes(ids: $ids) {
								... on Product {
									handle
									availableForSale
								}
							}
						}
					`,
					variables: {ids: pageIds},
				});
				
				await fetch(`https://${Shopify.shop}/api/2023-07/graphql.json`, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						"X-Shopify-Storefront-Access-Token": document.body.dataset.wishlistStorefrontToken,
					},
					body: query,
				}).then(response => response.json()).then(result => {
					products = products.concat(result.data.nodes);
					if (products && products.length > 0) {
						handles_available = products.filter(item => !!item?.availableForSale).map(item => item?.handle);
						handles_unavailable = products.filter(item => !item?.availableForSale).map(item => item?.handle);
					}
				});
				fetched += pageIds.length;
			} while (pageIds.length);
		} catch (error) {
			console.log(error);
		}

		return [...handles_available, ...handles_unavailable];
	}


	const loadWishlist = async () => {
		if (wishlistChanged) {
			var main = drawer.querySelector('.Drawer__Main');
			const container = drawer.querySelector('.Drawer__Main .Drawer__Container');

			const loader = document.createElement('div');
			loader.classList.add('BouncingSpinner');
			loader.append(document.createElement('span'));
			loader.append(document.createElement('span'));

			main.classList.add('empty');
			container.replaceChildren(loader);

			const handles = await getWishlistProductHandles();

			const loadProducts = async (page = 0) => {
				const pageOffset = page * pageSize;
				// Add 20 (or any other number, really) on the line below so the next page button appears
				const response = await fetch(`${Shopify.routes.root}?section_id=wishlist-products&cache=false&type=${Date.now()}_${Math.random()}&products=${handles.slice(pageOffset, pageOffset + pageSize + 20).join(',')}`);
				const result = new DOMParser().parseFromString(await response.text(), 'text/html');

				result.querySelectorAll('.cake-wishlist-icon').forEach(element => {
					element.addEventListener('click', () => {
						if (element.closest('.Drawer__Container').querySelectorAll('.QuickShopDrawer__Product').length > 1) {
							setTimeout(() => element.closest('.QuickShopDrawer__Product').remove(), 100);
						} else {
							loadProducts('', true);
						}
					});
				});

				if (page == 0) {
					main.replaceWith(result.querySelector('.Drawer__Main'));
					main = drawer.querySelector('.Drawer__Main');
				} else {
					if (!result.querySelector('.Drawer__Main.empty')) {
						main.querySelector('.Drawer__Container').append(...result.querySelectorAll('.Drawer__Container > *'));
					}
					loader.remove();
				}

				document.dispatchEvent(new Event('quickshop:refresh'));
				const button = main.querySelector('button[data-more-products]');
				if (button) {
					if (handles.length > pageOffset) {
						button.addEventListener('click', () => {
							button.replaceWith(loader);
							loadProducts(page + 1);
						});
					} else {
						button.remove();
					}
				}
			}

			loadProducts();

			wishlistChanged = false;
		} else {

		}
	}

	var _learnq = window['_learnq'] || [];


	//Used for adding / removing wishlist nav icon active state
	const updateButtons = items => {
		// Update header icon indicator
		document.querySelectorAll('.wishlist-nav-icon .Header__WishlistDot').forEach(indicator => {
			if (items.length > 0) {
				indicator.classList.add('is-visible');
			} else {
				indicator.classList.remove('is-visible');
			}
		});

		// Update add/remove buttons
		document.querySelectorAll('.cake-wishlist-icon.cake-product-in-wishlist').forEach(button => {
			button.classList.remove('cake-product-in-wishlist');
		});
		items.forEach(item => {
			document.querySelectorAll(`.cake-wishlist-icon[data-product-id="${item.product_id}"]`).forEach(button => {
				button.classList.add('cake-product-in-wishlist');
			});
		});

		document.querySelectorAll('.cake-wishlist-icon').forEach(button => {
			if (button.matches('.cake-product-in-wishlist')) {
				button.ariaLabel = button.dataset.ariaLabelRemove;
			} else {
				button.ariaLabel = button.dataset.ariaLabelAdd;
			}
		})
	}

	const track = async (event, id) => {

		try {
			var query = JSON.stringify({
				query: `
					query($id: ID!) {
						node(id: $id) {
							... on ProductVariant {
								id
								title
								sku
								price {
									amount
									currencyCode
								}
								compareAtPrice {
									amount
									currencyCode
								}
								product {
									id
									title
									collections(first: 50) {
										edges {
											node {
												title
											}
										}
									}
									featuredImage {
										url
									}
									onlineStoreUrl
								}
							}
							... on Product {
								id
								title
								collections(first: 50) {
									edges {
										node {
											title
										}
									}
								}
								featuredImage {
									url
								}
								onlineStoreUrl
								priceRange {
									maxVariantPrice {
										amount
										currencyCode
									}
								}
								compareAtPriceRange {
									maxVariantPrice {
										amount
										currencyCode
									}
								}
							}
						}
					}
				`,
				variables: {id}
			});
			
			await fetch(`https://${Shopify.shop}/api/2023-07/graphql.json`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"X-Shopify-Storefront-Access-Token": document.body.dataset.wishlistStorefrontToken,
				},
				body: query,
			}).then(response => response.json()).then(result => {
				const data = result.data.node;
				if (data && data.id) {
					var item = {};
					if (data.id.match('/Product/')) {
						item = {
							ProductID: data.id,
							Name: data.title,
							URL: data.onlineStoreUrl,
							Categories: data.collections.edges.map(edge => edge.node.title),
							Price: data.priceRange.maxVariantPrice.amount,
							CompareAtPrice: data.compareAtPriceRange.maxVariantPrice.amount,
							ImageURL: data.featuredImage.url,
						}
					} else if (data.id.match('/ProductVariant/')) {
						item = {
							ProductID: data.product.id,
							Name: data.title,
							URL: data.product.onlineStoreUrl,
							SKU: data.sku,
							Categories: data.product.collections.edges.map(edge => edge.node.title),
							Price: data.price ? data.price.amount : null,
							CompareAtPrice: data.compareAtPrice ? data.compareAtPrice.amount : null,
							ImageURL: data.product.featuredImage.url,
						}
					}
					_learnq.push(['track', event, item]);
				}
			});
		} catch (error) {
			console.log(error);
		}
	}

	const sendApiRequest = async (endpoint, data) => {
		return fetch(`https://wishlist.disturbia.app/${endpoint}`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"X-Cake-Customer-Wishlist-Token": token
			},
			mode: "cors",
			body: JSON.stringify(data),
		}).then(response => response.json());
	}

	const getGID = (productId, variantId) => {
		if (variantId) return `gid://shopify/ProductVariant/${variantId}`;
		return `gid://shopify/Product/${productId}`;
	}

	const addProduct = async (productID, variantID) => {
		document.querySelectorAll(`.cake-wishlist-icon[data-product-id="${productID}"]`).forEach(button => {
			button.classList.add('cake-product-in-wishlist');
		});
		try {
			const result = await sendApiRequest('wishlist/add', {
				shop: Shopify.shop || null,
				customer_id: customerID || null,
				product_id: productID || null,
				variant_id: variantID || null,
			});

			updateButtons(result.wishlist.items);

			await track('Added To Wishlist', getGID(productID, variantID));
		} catch (error) {
			console.log('Wishlist error:', error);
		}
	}
	
	const removeProduct = async (productID, variantID) => {
		document.querySelectorAll(`.cake-wishlist-icon[data-product-id="${productID}"]`).forEach(button => {
			button.classList.remove('cake-product-in-wishlist');
		});
		try {
			const result = await sendApiRequest('wishlist/remove', {
				shop: Shopify.shop || null,
				customer_id: customerID || null,
				product_id: productID || null,
				variant_id: variantID || null,
			});
			
			updateButtons(result.wishlist.items);
			
			await track('Removed From Wishlist', getGID(productID, variantID));
		} catch (error) {
			console.log('Wishlist error:', error);
		}
	}

	if (Cookies.get('cake_wishlist_add') && customerID) {
		const [prod, vari] = Cookies.get('cake_wishlist_add').split(':');
		Cookies.remove('cake_wishlist_add');
		addProduct(prod, vari);
	}

	delegate.on('click', '.cake-wishlist-icon', async function(event) { 
		event.preventDefault();
		const productID = event.target.dataset.productId || event.target.closest('[data-product-id]').dataset.productId;
			
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const variantID = urlParams.get('variant') || null;
		
		if (customerID) {
			const target = event.target.matches('.cake-wishlist-icon') ? event.target : event.target.closest('.cake-wishlist-icon');

			if (target.classList.contains('cake-product-in-wishlist')) {
				await removeProduct(productID, variantID);
			} else {
				await addProduct(productID, variantID);
			}
		} else {
			Cookies.set('cake_wishlist_add', `${productID}:${variantID}`);
			window.location.replace(`${Shopify.routes.root}account/login?return_url=${encodeURIComponent(document.location.href)}`);
		}
	});
})();